export var RedBlueBettingOptionClasses;
(function (RedBlueBettingOptionClasses) {
    RedBlueBettingOptionClasses["RED"] = "RED_WINS";
    RedBlueBettingOptionClasses["DRAW"] = "DRAW_WINS";
    RedBlueBettingOptionClasses["BLUE"] = "BLUE_WINS";
    RedBlueBettingOptionClasses["CORRECT_RED"] = "NUMBER_ROLLED_RED";
    RedBlueBettingOptionClasses["CORRECT_BLUE"] = "NUMBER_ROLLED_BLUE";
    RedBlueBettingOptionClasses["CORRECT_RED_BLUE"] = "NUMBER_ROLLED_RED_BLUE";
    RedBlueBettingOptionClasses["RED_ODD"] = "PIPS_RED_ODD";
    RedBlueBettingOptionClasses["BLUE_ODD"] = "PIPS_BLUE_ODD";
    RedBlueBettingOptionClasses["RED_EVEN"] = "PIPS_RED_EVEN";
    RedBlueBettingOptionClasses["BLUE_EVEN"] = "PIPS_BLUE_EVEN";
    RedBlueBettingOptionClasses["RED_MORE_3_5"] = "PIPS_RED_MORE_3_5";
    RedBlueBettingOptionClasses["BLUE_MORE_3_5"] = "PIPS_BLUE_MORE_3_5";
    RedBlueBettingOptionClasses["RED_LESS_3_5"] = "PIPS_RED_LESS_3_5";
    RedBlueBettingOptionClasses["BLUE_LESS_3_5"] = "PIPS_BLUE_LESS_3_5";
    RedBlueBettingOptionClasses["SUM_ODD"] = "PIPS_SUM_ODD";
    RedBlueBettingOptionClasses["SUM_EVEN"] = "PIPS_SUM_EVEN";
    RedBlueBettingOptionClasses["SUM_LESS_4_5"] = "PIPS_SUM_LESS_4_5";
    RedBlueBettingOptionClasses["SUM_MORE_4_5"] = "PIPS_SUM_MORE_4_5";
    RedBlueBettingOptionClasses["SUM_LESS_5_5"] = "PIPS_SUM_LESS_5_5";
    RedBlueBettingOptionClasses["SUM_MORE_5_5"] = "PIPS_SUM_MORE_5_5";
    RedBlueBettingOptionClasses["SUM_LESS_6_5"] = "PIPS_SUM_LESS_6_5";
    RedBlueBettingOptionClasses["SUM_MORE_6_5"] = "PIPS_SUM_MORE_6_5";
    RedBlueBettingOptionClasses["SUM_LESS_7_5"] = "PIPS_SUM_LESS_7_5";
    RedBlueBettingOptionClasses["SUM_MORE_7_5"] = "PIPS_SUM_MORE_7_5";
    RedBlueBettingOptionClasses["SUM_LESS_8_5"] = "PIPS_SUM_LESS_8_5";
    RedBlueBettingOptionClasses["SUM_MORE_8_5"] = "PIPS_SUM_MORE_8_5";
    RedBlueBettingOptionClasses["SUM_LESS_9_5"] = "PIPS_SUM_LESS_9_5";
    RedBlueBettingOptionClasses["SUM_MORE_9_5"] = "PIPS_SUM_MORE_9_5";
})(RedBlueBettingOptionClasses || (RedBlueBettingOptionClasses = {}));
